import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._t("title", function () {
          return [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Core.ExportDialog.titleTextCsv')) + "\n      ")];
        })];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c(VBtn, {
          class: `v-btn-x mx-1 bg-rounded-button-${_vm.color}`,
          attrs: {
            "rounded": "",
            "text": "",
            "color": _vm.color,
            "disabled": _vm.useBackgroundRunnerExport ? false : !_vm.formValid,
            "data-cy": "export_button"
          },
          on: {
            "click": _vm.submit
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fal " + _vm._s(_vm.exportButtonIcon))]), _vm._v("\n          Export\n      ")], 1)];
      },
      proxy: true
    }], null, true)
  }, [_c(VForm, {
    ref: "form",
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('p', {
    staticClass: "text-body-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Core.ExportDialog.subtitleText')) + "\n          ")]), _c('router-link', {
    attrs: {
      "to": _vm.backgroundJobsLink,
      "target": "_blank",
      "data-cy": "export_background_jobs_link"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Core.ExportDialog.backgroundJobsListPage')) + "\n          ")])], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('p', {
    staticClass: "text-body-2"
  }, [_vm._t("subtitleParagraph")], 2)])], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_vm._t("fields"), _c(VTextField, {
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.$i18n_t('Core.ExportDialog.nameLabel'),
      "type": "text",
      "data-cy": "export_job_name"
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  }), !_vm.useBackgroundRunnerExport ? _c(VTextField, {
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.$i18n_t('Core.ExportDialog.emailLabel'),
      "rules": _vm.emailRules,
      "type": "email"
    },
    model: {
      value: _vm.email,
      callback: function ($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  }) : _vm._e()], 2)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };